<template>
<div>
      <p class="text-sm">
     <slot></slot>
    </p>
</div>

</template>

<script>
export default {
  name: "BodyCard",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
